/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=08f9b3c3"
const script = {}

import "./App.vue?vue&type=style&index=0&id=08f9b3c3&lang=css"

import exportComponent from "/Users/chenqi/data/wwwroot/car.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__